import { Button, FormikField, ModalStyle as Modal } from "@hubrise/react-components"
import type { SelectRef } from "@hubrise/react-components"
import { Form, Formik } from "formik"
import * as React from "react"
import { useTranslation } from "react-i18next"

import useOptionListUsages from "Catalog/Edit/shared/hooks/useOptionListUsages"
import useEditor from "shared/hooks/useEditor"
import { OptionListId } from "shared/hubrise/ids"
import { IProduct, ISku } from "shared/hubrise/models"
import * as Sku from "shared/hubrise/utils/Sku"

interface AttachOptionListProps {
  onClose: () => void
  product: IProduct
  sku: ISku
}

type FormValues = { optionListIds: Array<string> }

const AttachOptionList = ({ onClose, product, sku }: AttachOptionListProps): JSX.Element => {
  const { t } = useTranslation()
  const { catalog, editor } = useEditor()
  const $selectRef = React.useRef<SelectRef>(null)
  const optionListUsages = useOptionListUsages("short")

  React.useEffect(() => $selectRef.current?.focus(), [])

  const handleSubmit = ({ optionListIds }: FormValues): void => {
    const optionListId = OptionListId(Number(optionListIds[0]))
    editor.sku.update(product.id, sku.id, "optionListIds", [...sku.optionListIds, optionListId])
    onClose()
  }

  const initialValues: FormValues = { optionListIds: [String(catalog.data.optionLists[0]?.id ?? "")] }

  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      <Form>
        <Modal.Header>
          <Modal.Title>{Sku.fullName(product, sku)}</Modal.Title>
          <Modal.Close onClick={onClose} />
        </Modal.Header>

        <Modal.Body>
          <FormikField.Select
            ref={$selectRef}
            name="optionListIds"
            label={t("product.option_lists.attach_modal.label")}
            withMargin
            options={catalog.data.optionLists.map((optionList) => ({
              label: [optionList.name, `(${optionListUsages(optionList)})`].join(" "),
              value: String(optionList.id),
            }))}
            searchable={true}
          />
        </Modal.Body>

        <Modal.Footer>
          <Button variant="primary" type="submit">
            {t("product.option_lists.attach_modal.action")}
          </Button>
          <Button variant="empty" onClick={onClose}>
            {t("general.cancel")}
          </Button>
        </Modal.Footer>
      </Form>
    </Formik>
  )
}

export default AttachOptionList
